import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import OptimizationCaseTableDto from '../dto/OptimizationCaseTableDto';

class OptimizationCaseTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'optimizationCaseTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<OptimizationCaseTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, OptimizationCaseTableDto)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} name
	 * @return {Promise<any>}
	 */
	clone(id, name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/clone`, { id, name, })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new OptimizationCaseTableService();
